import { UserRoleCodes } from '@/types'

import { checkRights } from '@/helpers'

export default [
  {
    path: 'dictionaries/item/:id?/general',
    name: 'manager-dictionaries-item-general',
    component: () =>
      import('../../../views/Manager/Dictionaries/ManagerDictionariesItemGeneral.vue'),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
  // {
  //   path: 'dictionaries/item/:id?/seo',
  //   name: 'manager-dictionaries-item-seo',
  //   component: () =>
  //     import('../../../views/Manager/Dictionaries/ManagerDictionariesItemSeo.vue'),
  //   beforeEnter: [checkRights],
  //   meta: {
  //     layout: 'TheManagerLayout',
  //     roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
  //   },
  // },
]
